import clsx from 'clsx'
import React from 'react'

import Fieldset from '@/components-latest/layout/Fieldset'
import Button from '@/components-latest/primitives/Button'
import { TrashCan } from '@/components-latest/primitives/Icons'

import Styles from './RemovableFieldSet.module.scss'

type RemovableProps = {
  label?: string
  onDeleteClick?: () => void
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

const RemovableFieldSet = ({
  label,
  onDeleteClick = () => {
    return
  },
  className,
  children,
  disabled
}: RemovableProps) => {
  return (
    <Fieldset
      className={clsx(className, Styles.removableWrapper)}
      variant="nextBody"
      weight="semiBold"
      label={label || ''}>
      <div className={Styles.removableField}>
        {children}
        <Button
          type="button"
          className={Styles.trashIcon}
          variant="transparent"
          onClick={onDeleteClick}
          disabled={disabled}
          data-testid="remove-field"
          icon={<TrashCan />}
        />
      </div>
    </Fieldset>
  )
}

export default RemovableFieldSet
